import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800 text-white py-20 px-6" style={{ backgroundColor: '#211915' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-16 mb-16">
          {/* Logo and Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/cjop348f_image.png" 
                alt="MCT - Meta Cell Technology" 
                className="h-16 w-auto brightness-0 invert opacity-90"
              />
            </div>
            <p className="text-silver-400 text-sm font-light">
              © 2026. Dermalis for Meta Cell Technology New Zealand. All rights reserved ©
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-2">
            <h4 className="text-lg font-light mb-6 text-white">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/plasma" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Plasma
                </Link>
              </li>
              <li>
                <Link to="/exosomes" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Exosomes
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-lg font-light mb-6 text-white">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#legal" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Legal notice
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#cookies" className="text-silver-300 hover:text-teal-400 transition-colors font-light text-sm">
                  Use of Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-10"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Social Media */}
          <div className="flex gap-6 mb-6 md:mb-0">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-silver-400 hover:text-teal-400 transition-all hover:scale-110"
            >
              <Linkedin className="w-6 h-6" strokeWidth={1.5} />
            </a>
            <a
              href="https://www.instagram.com/mctmetacelltech_nz"
              target="_blank"
              rel="noopener noreferrer"
              className="text-silver-400 hover:text-teal-400 transition-all hover:scale-110"
            >
              <Instagram className="w-6 h-6" strokeWidth={1.5} />
            </a>
          </div>

          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-3 text-silver-400 hover:text-teal-400 transition-all group font-light text-sm"
          >
            Back to top
            <ArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;